module.exports = __webpack_public_path__ + "img/portfolio-img1.ea65c77d.png";